import { useSelector } from "react-redux";
import { RootState } from "../../store";
import styles from "./index.module.css";
import ActionButtons from "./ActionButtons";

interface ResponsiveDataTableProps {
    handleClick: (actionType: string, appointmentClientId: string ) => void
}

const ResponsiveDataTable: React.FC<ResponsiveDataTableProps> = ({ handleClick }) => {

    const emailState = useSelector((state: RootState) => state.emailState);
    const { followUpEmailList } = emailState;
   
    return (
        <div className={styles.responsive_product_table}>
            {followUpEmailList.map(followUpEmail => {
                const { _id, title, followUpHours } = followUpEmail;
                return (
                    <div 
                        key={_id}
                        className={styles.responsive_item}
                    >
                        <div className={styles.responsive_item_header}>
                            <p className={styles.responsive_item_name}>{title}</p>
                            <ActionButtons 
                                itemId={_id}
                                showButtonText={false}
                                handleClick={handleClick}
                            />
                        </div>
                        <div className={styles.responsive_other_info}>
                            <p>{followUpHours}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    );

}

export default ResponsiveDataTable;
